import { render, staticRenderFns } from "./professional-tab.vue?vue&type=template&id=6e5f140f"
import script from "./professional-tab.vue?vue&type=script&lang=js"
export * from "./professional-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports